const CptName = 'ComIframe'
function formatData (node) {
  // console.dir(node);
  setIframeWidthHeight(node)
  return {
    data: {
      html: node.outerHTML,
      src: node.src
    },
    cpt: CptName
  }
}

function setIframeWidthHeight (node) {
  node.setAttribute('width', '100%')
  node.setAttribute('height', '100%')
}

export default {
  name: 'iframe',
  formatData
}